<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>My Old Faithful</h1>
<h1 class="bk1">Stories</h1>
<p class="bkau">Yang Huang</p>
<p class="bkpub">University of Massachusetts Press</p>
<p class="bkpub1"><i>Amherst and Boston</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-HUANG-0005.vue?de30491a